<template>
  <div class="slider">
    <div class="slider__header">
      <div class="slider__category">
        <div class="slider__category-title">
          {{ category.title }}
        </div>
        <div class="slider__category-link">
          <a href="/catalog" class="category-link">
            <span>Все ароматы</span>

            <span class="icon-next">
              <div class="eik-i eik-i-arrow"></div>
            </span>
          </a>
          <div class="slider__navigation">
            <div class="navigation-pages">
              <span class="active">{{  thisPage }}</span>
              <span class="separator"></span>
              <span>{{ lastPage }}</span>
            </div>
            <div class="navigation-arrows">
              <div
                  class="navigation-arrow-left"
                  :class="{ 'navigation-arrow_disabled': thisPage == 1 }"
                  @click="showPrev"
              >
                <div class="eik-i eik-i-arrow eik-i-arrow-left"></div>
              </div>
              <div
                  class="navigation-arrow-right"
                  :class="{ 'navigation-arrow_disabled': thisPage == lastPage }"
                  @click="showNext"
              >
                <div class="eik-i eik-i-arrow eik-i-arrow-right"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
        class="slider__slides"
        :data-slider="slideIndex"
    >
      <slick-carousel
          v-if="slides"
          v-bind="settings"
          ref="carousel"
          @afterChange="afterChange"
      >
        <div
            class="slider__content"
            v-for="(slide, index) in slides"
            :key="index"
        >
          <div class="slider__slide">
            <div class="slider__block">
              <div class="slider__block-button">
                  {{ 'Виды упаковок данного аромата' }}
              </div>
              <div class="slider__block-header">
                <div class="slider__block-title">
                  {{slide.titleDefault}}
                </div>
                <div class="slider__block-more">
                  {{slide.titleRuDefault}}
                </div>
                <div
                    class="slider__block-description"
                    v-html="slide.descriptionDefault"
                >
                </div>
              </div>
              <div class="slider__block-products">
                <div
                    v-for="(product, pi) in slideProducts(slide)"
                    class="slide__product"
                    :key="pi"
                >
                  <span>
                    <div class="slide__product-image">
                      <img
                          :alt="product.article"
                          :src="getImage(product.fileDefault)"
                      />
                    </div>
                    <div class="slide__product-info">
                      <div class="infobox">
                        {{ packageTitle(product) }}
                        <br>
                        {{ product.article }}
                      </div>
                    </div>
                  </span>
                </div>
              </div>
              <MarketplaceButton />
            </div>
            <div class="slider__image">
              <img
                  :alt="slide.titleDefault"
                  :src="slideImage(slide)"
              />
            </div>
          </div>
        </div>
      </slick-carousel>
    </div>
  </div>
</template>

<script>
import utils from '../utils'
import SlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import MarketplaceButton from './MarketplaceButton.vue'

export default {
  props: {
    item: null,
    slideIndex: null,
    isDevice: null,
  },
  components: {
    SlickCarousel,
    MarketplaceButton
  },
  data() {
    return {
      slides: this.item ? this.item.slides : null,
      category: this.item ? this.item.category : null,
      settings: {
        "dots": false,
        "arrows": false,
        "fade": false,
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "lazyLoad": this.isDevice === 'desktop' ? "ondemand" : "false",
        "adaptiveHeight": true
      },
      wait: false,
      thisPage: 1,
      lastPage: this.item ? this.item.slides.length : 1,
    }
  },
  methods: {
    slideProducts(slide) {
      const products = Array.isArray(slide?.products) ? [...slide.products] : []
      return products.sort((a, b) => {
        const sa = a.sort_order ?? a.sortOrder
        const sb = b.sort_order ?? b.sortOrder
        if (sa == null && sb == null) {
          return (a.product_id ?? a.id ?? 0) - (b.product_id ?? b.id ?? 0)
        }
        if (sa == null) return 1
        if (sb == null) return -1
        return sa - sb || (a.product_id ?? a.id ?? 0) - (b.product_id ?? b.id ?? 0)
      })
    },
    packageTitle(product) {
      const pkg = product?.package
      if (pkg && typeof pkg === 'object') {
        return pkg.title || ''
      }
      return pkg || ''
    },
    getImage(type, name) {
      const { getStaticImage } = utils()
      return getStaticImage(type, name)
    },
    slideImage(slide) {
      const file = slide.cover_url || slide.file
      if (!file) return ''
      const s = String(file)
      if (s.startsWith('http') || s.startsWith('//') || s.startsWith('/')) {
        return this.getImage(s)
      }
      return this.getImage('slider', s)
    },
    imagePath(product) {
      const file = product.fileDefault || product.file || ''
      const s = String(file)
      if (s.startsWith('http') || s.startsWith('//') || s.startsWith('/')) {
        return s
      }
      return s
    },
    showNext() {
      if (!this.wait && this.thisPage !== this.lastPage) {
        this.wait = true;
        this.$refs.carousel.next()
        this.thisPage = this.thisPage + 1
        setTimeout(() => this.wait = false, this.settings.speed + 100);
      }
    },
    showPrev() {
      if (!this.wait && this.thisPage !== 1) {
        this.wait = true;
        this.$refs.carousel.prev()
        this.thisPage = this.thisPage - 1
        setTimeout(() => this.wait = false, this.settings.speed + 100);
      }
    },
    afterChange(page) {
      this.thisPage = page + 1
    },
  }
}
</script>